import { Injectable } from '@angular/core';
import { Observable, Observer, of } from 'rxjs';
import { MessageService } from 'primeng/api';

declare var google: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleApiService {
  geocoder: any;

  constructor(private messageService: MessageService) {
    // Inicializa apenas se o Google Maps estiver disponível
    if (typeof google !== 'undefined' && google?.maps) {
      this.geocoder = new google.maps.Geocoder();
    }
  }

  private ensureGeocoderInitialized() {
    if (!this.geocoder && typeof google !== 'undefined' && google?.maps) {
      this.geocoder = new google.maps.Geocoder();
    }
  }

  /**
   * Reverse geocoding by location.
   *
   * Wraps the Google Maps API geocoding service into an observable.
   *
   * @param latLng Location
   * @return An observable of GeocoderResult
   */
  geocode(latLng: any): Observable<any[]> {
    this.ensureGeocoderInitialized();
    
    if (!this.geocoder) {
      return of([]);
    }
    
    return Observable.create((observer: Observer<any[]>) => {
      // Invokes geocode method of Google Maps API geocoding.
      this.geocoder.geocode(
        { location: latLng },
        (results: any[], status: any) => {
          if ((status === undefined || status == null ? '' : status).toString() === 'ZERO_RESULTS') {
            this.messageService.add({
              severity: 'error',
              summary: 'Pesquisa Coordenadas',
              detail: `Erro ao localizar às coordenadas. Verifique o endereço informado.`,
            });
          } else if (status === google.maps.GeocoderStatus.OK) {
            observer.next(results);
            observer.complete();
          } else {
            console.log('Geocoding service: geocoder failed due to: ' + status);
            observer.error(status);
          }
        }
      );
    });
  }

  /**
   * Geocoding service.
   *
   * Wraps the Google Maps API geocoding service into an observable.
   *
   * @param address The address to be searched
   * @return An observable of GeocoderResult
   */
  codeAddress(address: string): Observable<any[]> {
    this.ensureGeocoderInitialized();
    
    if (!this.geocoder) {
      return of([]);
    }
    
    return Observable.create((observer: Observer<any[]>) => {
      // Invokes geocode method of Google Maps API geocoding.
      this.geocoder.geocode(
        { address: address },
        (results: any[], status: any) => {
          if ((status === undefined || status == null ? '' : status).toString() === 'ZERO_RESULTS') {
            this.messageService.add({
              severity: 'error',
              summary: 'Pesquisa Coordenadas',
              detail: `Erro ao localizar às coordenadas. Verifique o endereço informado.`,
            });
          } else if (status === google.maps.GeocoderStatus.OK) {
            observer.next(results);
            observer.complete();
          } else {
            console.log('Geocoding service: geocode was not successful for the following reason: ' + status);
            observer.error(status);
          }
        }
      );
    });
  }
}
